/**
 * Scrolls a condition into view and flash-highlights it. The highlight is the
 * actual feedback: when the condition is already on screen (small patterns),
 * scrollIntoView alone is a visual no-op and the button looks broken.
 * Imperative DOM helper (no theme context) — the glow matches primary.main.
 */
export const revealCondition = (conditionId: string): boolean => {
  const el = document.querySelector(`[data-condition-id="${conditionId}"]`) as HTMLElement | null
  if (!el) return false
  el.scrollIntoView({ behavior: 'smooth', block: 'center' })
  const prevShadow = el.style.boxShadow
  const prevRadius = el.style.borderRadius
  const prevTransition = el.style.transition
  el.style.transition = 'box-shadow 0.3s ease'
  el.style.borderRadius = '8px'
  el.style.boxShadow = '0 0 0 2px #1DC30E, 0 0 14px 2px rgba(29, 195, 14, 0.55)'
  window.setTimeout(() => {
    el.style.boxShadow = prevShadow
    window.setTimeout(() => {
      el.style.borderRadius = prevRadius
      el.style.transition = prevTransition
    }, 350)
  }, 1600)
  return true
}
